import type { AlgebraExperimentDef, ExperimentKey } from '../types';
import * as equationBalance from './equation-balance';
import * as factorTiles from './factor-tiles';
import * as quadraticWorkshop from './quadratic-workshop';
import * as polynomialArithmetic from './polynomial-arithmetic';
import * as systemsLaboratory from './systems-laboratory';
import * as inequalityLine from './inequality-line';
import * as sequencesStaircase from './sequences-staircase';
import * as expressionRewriter from './expression-rewriter';

// The full registry of all eight experiments.
export const EXPERIMENTS: Record<ExperimentKey, AlgebraExperimentDef> = {
  'equation-balance': equationBalance.experiment,
  'factor-tiles': factorTiles.experiment,
  'quadratic-workshop': quadraticWorkshop.experiment,
  'polynomial-arithmetic': polynomialArithmetic.experiment,
  'systems-laboratory': systemsLaboratory.experiment,
  'inequality-line': inequalityLine.experiment,
  'sequences-staircase': sequencesStaircase.experiment,
  'expression-rewriter': expressionRewriter.experiment,
};
